module.exports = __webpack_public_path__ + "static/media/Subscriber-Exclusive-Desktop-Banner-2440x300px.453ba729.jpg";